import Service from './Service';

const resource = '/api/parentescos';

export default {
    index() {
        return Service.get(`${resource}`);
    }
}
